export default __webpack_public_path__ + "static/media/Team.b5711237.jpg";